export default __webpack_public_path__ + "static/15-fa963fd26d48fc73dc4c2668e216e052.webp";